export default __webpack_public_path__ + "static/media/aboutBanner.ac02080f.png";